import contextCreator from "../contextCreator";
import listingsListReducer, {
  initialState,
  savePolygonMiddleware,
} from "./listingsList.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  listingsListReducer,
  initialState,
  [savePolygonMiddleware]
);

export const useListingsListState = state;
export const useListingListDispatch = dispatch;
export const ListingListProvider = provider;
